import React from 'react';
import './UnAuthorizedHeader.css'
import logo from '../../img/loomis-logo.svg';
import { Row, Col } from 'react-flexbox-grid';

const UnAuthorizedHeader = (props) => {

    const {header, text} = props;

    return (
        <div className="UnAuthorizedHeader">
            <div className="container">
                <Row>
                    <Col xs={12}>
                        <Row center="xs">
                            <Col xs={12} sm={6} md={4}>
                                <img className="login-logo" src={logo} alt="Loomis"/>
                                <div className="UnAuthorizedHeaderText">
                                    <h2>{header}</h2>
                                    {text}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default UnAuthorizedHeader;



// WEBPACK FOOTER //
// ./src/components/UnAuthorizedHeader/UnAuthorizedHeader.js